import _ from "lodash";

/**
 * Resolves external links that combine `endpointPath` (e.g. config env URL) with `redirect.path`.
 */
export function resolveTemplateExternalHref(options: {
  redirect?: { path?: string; type?: string };
  endpointPath?: string;
}): string {
  const path = options.redirect?.path || "";
  if (!path) {
    return "";
  }
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  let base = window.location?.origin || "";
  if (options.endpointPath === "environment.aemHomePageUrl") {
    base =
      window.partnerRegistrationConfig?.REACT_APP_DXP_URL ||
      window.partnerRegistrationConfig?.REACT_APP_AEM_HOME_URL ||
      base;
  } else if (options.endpointPath) {
    const fromConfig = _.get(
      window.partnerRegistrationConfig,
      options.endpointPath,
    );
    if (typeof fromConfig === "string") {
      base = fromConfig;
    }
  }

  const baseNorm = base.replace(/\/$/, "");
  const pathNorm = path.replace(/^\//, "");
  if (!pathNorm) {
    return baseNorm;
  }
  return `${baseNorm}/${pathNorm}`;
}
